"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class StudentParentConnectionNotFoundInClass extends client_library_1.ExtendableError {
    constructor() {
        super('No connection found between the student and parent in this class');
    }
}
exports.default = StudentParentConnectionNotFoundInClass;
//# sourceMappingURL=StudentParentConnectionNotFoundInClass.js.map